export const areAllChainsSelected = (
  chains: number[],
  selectedChains: number[],
) => chains.every((chain) => selectedChains.includes(chain));
